module.exports = __webpack_public_path__ + "img/80.40ad2d94.jpg";